export enum TwoFactorAuthenticationScopesSMSType {
  SetPhoneNumber = "set-phone-number",
  InsertCode = "insert-code"
}

export enum TwoFactorAuthenticationType {
  SMS = "SMS",
  EMAIL = "EMAIL"
}
